import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "pirate-source-distribution",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Review the distribution of identified piracy sources.",
    domain: "detections",
    visual: "Donut chart",
    purposes: ["live"],
    audiences: ["analyst", "client"],
  },
  layout: {
    kind: "chart",
    skeleton: "donut",
    // The summary presentation is one bar and its key: sized by its content.
    byConfig: (config) =>
      config.presentation === "summary" ? { kind: "content", skeleton: "share" } : {},
  },
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
